import PropTypes from 'prop-types';

const ChartLegend = ({ items, colors }) => (
  <div className="mt-4 bg-white/80 rounded-xl p-3 flex flex-wrap gap-2 justify-center">
    {items.map((item, i) => {
      const isNegative = item.value < 0;
      const color = colors[i % colors.length];

      return (
        <div key={`${item.label}-${i}`} className="flex items-center space-x-1">
          <div className={`w-3 h-3 rounded ${color}`}></div>
          <span className={`text-xs ${isNegative ? 'text-green-700' : 'text-gray-700'}`}>{item.label}</span>
        </div>
      );
    })}
  </div>
);

ChartLegend.propTypes = {
  items: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
};

export default ChartLegend;
